/* eslint-disable react/display-name */
import { forwardRef, useMemo } from 'react';
import {
  StyledBody,
  StyledCardBody,
  StyledHead,
  StyledHead2,
  StyledHead3,
  StyledHead4,
} from './StyledText';
import type { TextProps } from './Props';
import * as DOMPurify from 'dompurify';
import Linkify from 'react-linkify';
import { Box, BoxProps } from '@chakra-ui/react';
import styled from '@emotion/styled';

const TextTags: Dict = {
  h1: StyledHead,
  h2: StyledHead2,
  h3: StyledHead3,
  h4: StyledHead4,
  body: StyledBody,
  cardBody: StyledCardBody,
};

const StyledHTMLContainer = styled.div<{ maxLines?: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ maxLines }) => maxLines || 99999};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Text = forwardRef<
  HTMLHeadingElement | HTMLDivElement,
  TextProps & BoxProps
>(({ children, type = 'body', html, maxLines, ...otherProps }, ref) => {
  const TagName = TextTags[type] || StyledBody;
  const htmlData = useMemo(
    () => (html ? DOMPurify.sanitize(html) : null),
    [html]
  );
  return (
    <Box {...otherProps}>
      {htmlData ? (
        <StyledHTMLContainer
          maxLines={maxLines}
          dangerouslySetInnerHTML={{ __html: htmlData }}
        ></StyledHTMLContainer>
      ) : (
        <TagName {...otherProps} ref={ref}>
          <Linkify>{children}</Linkify>
        </TagName>
      )}
    </Box>
  );
});

export default Text;
